import { PageHeader } from '@fukuri-admins/ui/common';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { CreateInternalNews } from '~/features/CreateInternalNews';
import { ROUTES } from '~/utils/routes';
import styles from './styles.module.scss';

/**
 * 社内報作成 Screen
 */
export const Screen: React.FC = () => (
  <div className={styles.screen}>
    <ClientSideMenu />
    <div className={styles.content}>
      <PageHeader
        variant='breadcrumb'
        breadcrumbItems={[
          { label: '社内報', href: ROUTES.INTERNAL_NEWS.INDEX },
          { label: '新規作成' },
        ]}
      />
      <main className={styles.body}>
        <CreateInternalNews />
      </main>
    </div>
  </div>
);
